var exports = {
  "N": "xa15a2ab7--f6540b--body-wrapper",
  "U": "xa15a2ab7--f6540b--footer-wrapper",
};

module.exports = exports;
